import { CaseStudy, CaseStudyTemplate, Company } from "../CaseStudy";
import technologies from "../technologies";


import swfpaThumbnail from "../../../../assets/img/caseStudies/swfpa.webp";
import swfpaLogo from "../../../../assets/img/clients/swfpa.webp";

export const Swfpa = () => {
 const caseStudy = new CaseStudyTemplate(
  "SWFPA: Crew and Vessel Contract & Safe Working Tool ",
  (
   <div>
    <p>
     The fishing industry needs effective systems to manage vessel and crew contracts while ensuring legal and safety compliance. SWFPA required a streamlined solution to handle contracts, track crew qualifications, and enable secure communication—both at sea and onshore.
    </p>
    <p>DEV4 partnered with SWFPA to deliver bespoke tools tailored to the fishing sector. Key features:</p>
    <ul>
     <li>Centralised contract management with compliance tracking.</li>
     <li>Integration with a dedicated mobile app, for secure access to important information.</li>
     <li>A communication platform connecting crew members with onshore management and support networks, promoting safety and well-being at sea.</li>
    </ul>
    <strong>The Results</strong>
    <ul>
     <li>Compliance & Safety: Enhanced tracking of crew qualifications and legal compliance.
     </li>
     <li>Empowered Crew: Crews gain secure, easy access to information and support.
     </li>
     <li>Streamlined Operations: Onshore teams benefit from simplified, real-time contract oversight.
     </li>
    </ul>
   </div>
  ),
  swfpaThumbnail,
  new Company(
   "SWFPA",
   swfpaLogo,
   {
    width: "12.5%"
   }
  ),
  "https://swfpa.com/",
  [
   technologies.PWA,
   technologies.vueJS,
   technologies.azure,
   technologies.sqlServer,
  ]
 )

 return (
  <CaseStudy caseStudy={caseStudy} bgColor="rgb(252, 201, 162)" thumbSize="110%"></CaseStudy>
 )
}